import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface TenantConfig {
  id: string;
  slug: string;
  name: string;
  config: Record<string, unknown>;
}

interface TenantContextType {
  tenant: TenantConfig | null;
  loading: boolean;
  error: string | null;
}

const TenantContext = createContext<TenantContextType | undefined>(undefined);

export const TenantProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [tenant, setTenant] = useState<TenantConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error] = useState<string | null>(null);

  useEffect(() => {
    // TODO: Fetch tenant configuration from API
    // For now, mock tenant data
    const mockTenant: TenantConfig = {
      id: import.meta.env.VITE_DEFAULT_TENANT_ID || '996d78a2-6ffe-4540-8a2e-f4719a4580cc', // Demo Tenant UUID
      slug: window.location.hostname.split('.')[0] || 'demo',
      name: 'Demo Tenant',
      config: {},
    };

    // Store tenant ID in localStorage for API client
    // The API client reads this to set X-Tenant-ID header
    localStorage.setItem('quiz_commerce_tenant_id', mockTenant.id);

    setTenant(mockTenant);
    setLoading(false);
  }, []);

  return (
    <TenantContext.Provider value={{ tenant, loading, error }}>
      {children}
    </TenantContext.Provider>
  );
};

export const useTenant = (): TenantContextType => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within TenantProvider');
  }
  return context;
};
